import { gql, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import { MEASURE_FIELDS, NULLABLE_MEASURE_FIELDS } from '../../queries';
import { getMonths } from '../../utils';
import {
  ForecastPageLimitsResponse,
  InputFieldLimitsQuery,
  InputFieldLimitsQueryVariables,
} from '../../generated/graphql';

export type { ForecastPageLimitsResponse } from '../../generated/graphql';

export const inputFieldLimitsQuery: TypedDocumentNode<InputFieldLimitsQuery, InputFieldLimitsQueryVariables> = gql`
  query InputFieldLimits($device: ForecastPageDeviceInput!, $months: [Month!]!) {
    getForecastLimits(device: $device, months: $months) {
      installedPower {
        ...NullableMeasureFields
      }
      fields {
        type
        lowerLimit {
          limitSpecification
          limit {
            ...MeasureFields
          }
        }
        upperLimit {
          limitSpecification
          limit {
            ...MeasureFields
          }
        }
        isDisabled
        negativeBand {
          ...NullableMeasureFields
        }
        positiveBand {
          ...NullableMeasureFields
        }
      }
    }
  }
  ${MEASURE_FIELDS}
  ${NULLABLE_MEASURE_FIELDS}
`;

export function useInputFieldLimits(
  marketLocationId: string,
  deviceId: string,
  dateInput: Parameters<typeof getMonths>[0],
): ForecastPageLimitsResponse {
  const months = getMonths(dateInput);
  if (months.length === 0) {
    throw new TypeError('At least one month must be selected.');
  }

  const { data } = useSuspenseQuery(inputFieldLimitsQuery, {
    variables: { months, device: { marketLocationId, deviceId } },
  });

  return data.getForecastLimits;
}
